<div>
  <ion-item *ngFor="let item of categoty_list;let index=index;" (click)="get_items(item,index)" routerLinkActive="active-link" [routerLinkActiveOptions]={exact:true} (click)="menuCtrl.close()">
    <div class="item">
      <div>{{item.category_name}}</div> <span *ngIf="item.Items" class="badge">{{item.Items.length}}</span>
      <!-- <ion-icon class="floatRight" name="chevron-forward-outline"></ion-icon> -->
    </div>
  </ion-item>
</div>
